"use client"

import { ReactNode } from "react"
import type { QueryClient } from "@tanstack/react-query"
import { AccountsProvider } from "@/contexts/AccountsContext"
import { QueryProvider } from "@/components/providers/query-provider"
import { OrchestratorProvider } from "@/contexts/OrchestratorContext"
import { WorkflowBanner } from "@/components/orchestrator/WorkflowBanner"
import { SessionProvider } from "@/lib/session-context"
import type { AuthUser } from "@/lib/auth-server"

export function Providers({
  children,
  user,
  lightweight = false,
  queryClient,
}: {
  children: ReactNode
  user: AuthUser | null
  lightweight?: boolean
  /** SPA: shared QueryClient (see web/src/query-client.ts). Next shell omits it. */
  queryClient?: QueryClient
}) {
  const appContent = lightweight ? (
    children
  ) : (
    <AccountsProvider>
      <OrchestratorProvider>
        {children}
        <WorkflowBanner />
      </OrchestratorProvider>
    </AccountsProvider>
  )

  return (
    <SessionProvider user={user}>
      <QueryProvider client={queryClient}>
        {appContent}
      </QueryProvider>
    </SessionProvider>
  )
}
